(() => {
  'use strict';

  async function parseResponse(response) {
    const text = await response.text();
    let result = {};

    try {
      result = JSON.parse(text);
    } catch (error) {
      console.error('Kenzu: respuesta inválida de Shopify.', text);
    }

    if (!response.ok || result.status) {
      const message =
        result.description ||
        result.message ||
        result.errors ||
        text ||
        `Error HTTP ${response.status}`;

      throw new Error(
        typeof message === 'string'
          ? message
          : JSON.stringify(message)
      );
    }

    return result;
  }

  async function addItems(items, source, productVariantId) {
    if (!Array.isArray(items) || !items.length) {
      throw new Error('No existen productos para agregar.');
    }

    const cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    const body = {
      items,
      sections_url: window.location.pathname
    };

    if (cart?.getSectionsToRender) {
      body.sections = cart
        .getSectionsToRender()
        .map((section) => section.id);
    }

    cart?.setActiveElement?.(document.activeElement);

    const response = await fetch(
      window.routes?.cart_add_url || '/cart/add.js',
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      }
    );

    const result = await parseResponse(response);

    if (cart?.renderContents) {
      cart.classList.remove('is-empty');
      cart.renderContents(result);
    } else {
      window.location.assign(window.routes?.cart_url || '/cart');
    }

    if (
      typeof window.publish === 'function' &&
      window.PUB_SUB_EVENTS?.cartUpdate
    ) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source,
        productVariantId,
        cartData: result
      });
    }

    return result;
  }

  window.KenzuCart = {
    addItems
  };
})();